// extracted by mini-css-extract-plugin
export var colors = "'colors.module.css'";
export var orangeText = "#FF5A09";
export var whiteText = "#dcdcdc";
export var cream = "#1d1e22";
export var header = "header-module--header--Zms1V";
export var nav = "header-module--nav--e8OJ3";
export var list = "header-module--list--t2WNE";
export var link = "header-module--link--muri5";
export var activeLink = "header-module--activeLink--fEy75 header-module--link--muri5";